function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { VSelect } from 'vuetify/lib';
import FormMixin from '../form.mixin';
import template from './dosage-form-dropdown.html';

var Select = /*#__PURE__*/function () {
  function Select() {
    _classCallCheck(this, Select);
  }

  _createClass(Select, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-dosage-form-dropdown', {
        template: template,
        mixins: [FormMixin],
        components: {
          VSelect: VSelect
        },
        computed: {
          items: function items() {
            if (this.$attrs.items) return this.$attrs.items;
            return [];
          }
        },
        methods: {
          onChange: function onChange(e) {
            this.$emit('input', e.label);
          }
        }
      });
    }
  }]);

  return Select;
}();

export default Select;